import dotsBottom from "../../assets/login-dots-bottom.svg";
import dotsTop from "../../assets/login-dots-top.svg";
import vectorArt from "../../assets/login-vector-art.png";
import createPasswordVectorArt from "../../assets/create-password-vector-art.svg";
import logo from "../../assets/top-nav-logo.svg";
import { useEffect, useMemo, useState } from "react";
import { useDispatch } from "react-redux";
import { JService } from "../api-service/ApiService";
import { useLocation, useNavigate } from "react-router-dom";
import { CustomInput, ErrorMessage } from "../design/components/customComponents";
import { saveAccountDetails } from "../features/account/account";
import { enqueueSnackbar } from "notistack";
import { login, setRedirectOnAuth } from "../features/user/user";
import { getPasswordStrength, strengthColors } from '../../utility-functions'
import Button from '../design/Button'
import { reduxPersistSelectedVirtualNumber } from "../features/virtual-number/virtualNumber";

const API_BASE_URL = process.env.REACT_APP_BETA;
function ForgotPasswordReset() {
    const dispatch = useDispatch()
    const location = useLocation();
    const navigate = useNavigate()

    const [password,setPassword]=useState({value:'',error:null})
    const [confirmPassword,setConfirmPassword]=useState({value:'',error:null})
    const [passwordStrength, setPasswordStrength] = useState(null)
    const [isLoading, setIsLoading] = useState(false);
    
    const handleFocus=(e)=>{
        const name=e.target.name
        if(name==='password')
            setPassword(prev=>({...prev,error:null}))
        else if(name==='confirmpassword')
            setConfirmPassword(prev=>({...prev,error:null}))
    }

    const handleSubmit = e => {
        e.preventDefault()
		if(password.value !== confirmPassword.value) {
            setPassword(prev=>({...prev, error:'Passwords do not match'}))
            setConfirmPassword(prev=>({...prev, error:'Passwords do not match'}))
            return;
        }
        setIsLoading(true);
        JService.post(API_BASE_URL + '/api/v1/auth/reset-password/', JSON.stringify({password:password.value, confirm_password: confirmPassword.value}))
        .then(res => {
            if(!res?.success) throw new Error(res?.message || `Error occurred while resetting password`)
            dispatch(login({email: location?.state?.email}))
			enqueueSnackbar(res?.message || 'Password (re)set', { variant: "success"})
            if(location?.state?.from === 'invite') {
                JService.get("/api/v1/auth/retrieve-account-profile/")
                .then((res) => {
                    if (!res?.success) throw Error("Failed to fetch account details");
                    dispatch(saveAccountDetails(res));
                    if (res?.data?.profile?.primary_virtual_number) {
                        dispatch(
                          reduxPersistSelectedVirtualNumber(
                            res?.data?.profile?.primary_virtual_number
                          )
                        );
                    }
                    dispatch(setRedirectOnAuth(true));
                })
                .catch((err) => {        
                  console.warn(err)
              })
                return;
            }
            navigate("/login", {replace: true})
        })
		.catch(err => enqueueSnackbar(err?.message || 'Error occurred while (re)setting password', { variant: "error"}))
        .finally(() => setIsLoading(false));
    }

    useEffect(() => {
        if (password.value) {
        const strength = getPasswordStrength(password.value);
        setPasswordStrength(strength);
        } else {
        setPasswordStrength(null);
        }
    }, [password]);

    const buttonDisabled = useMemo(() => !password.value || !confirmPassword.value || !password.value.length || !confirmPassword.value.length || password.value !== confirmPassword.value, [password, confirmPassword]);

    const errorMessage = useMemo(() => {
        if ((password.value && confirmPassword.value) && password.value !== confirmPassword.value) return "Passwords do not match";
        return "";
    }, [password, confirmPassword]);

    const fromInvite = location?.state?.from === 'invite' ;

    return(
		<div className='signup-screen-container'>
			<div className='signup-art'>
			<img className='dots-top' src={ dotsTop } alt=""/>
            <a href="https://frejun.com/" target="_blank" rel="noopener noreferrer"> <img src={logo} alt="Logo" /></a>
			<img style={{width: fromInvite ? '60vmin': "255px", height: !fromInvite ? "190px": "unset"}} src={ fromInvite ? vectorArt : createPasswordVectorArt } alt="illustrstion"/>
			<img src={ dotsBottom } alt=""/>
			{location?.state?.from === 'invite' && <p className='normal-font-poppins px-18'>Simplify and Automate<br/>Your Calling Process</p>}
			</div>
			<div className='signup-screen2-form' style={{justifyContent:'center'}}>
				<p className='title t5 medium-font'>{location?.state?.from === 'invite'?'Create':'Reset'} your password</p>
				<form onSubmit={e => handleSubmit(e)}>

					<CustomInput label={`${location?.state?.from === 'invite'?'':'New'} Password`} value={password} handleChange={(e)=>setPassword(prev=>({...prev,value:e.target.value}))} type="password" name="password" handleFocus={handleFocus} labelStyles={{marginBottom: '5px'}}/>

                    {passwordStrength && (<div style={{ color: strengthColors[passwordStrength]}}><p className='t7 medium-font'>Password Strength: {passwordStrength}</p></div>)}<br/>

					<CustomInput label='Confirm password' value={confirmPassword} handleChange={(e)=>setConfirmPassword(prev=>({...prev,value:e.target.value}))} type="password" name="confirmpassword" handleFocus={handleFocus} labelStyles={{marginBottom: '5px'}}/>

                    <ErrorMessage message={errorMessage} />

                    <div className='buttons-container btnscreen2 ' style={{justifyContent:'flex-end'}}>
                    <Button
                        buttonText={`${location?.state?.from === 'invite' ? 'Create' : 'Reset'} Password`}
                        onClick={handleSubmit}
                        styleOverride={{width: '100%'}}
                        spanStyles={{width: '100%'}} 
                        className="password-reset-btn"
                        variant="contained"
                        hierarchy="green"
                        type='submit'
                        isLoading={isLoading}
                        disabled={buttonDisabled}
                        title={errorMessage}
                    />
                    </div>
				</form>
			</div>
		</div>
    )
}

export default ForgotPasswordReset
